.metricContainer {
    display: flex;
    flex-direction: row;
}

.metricName {
    min-width: 350px;
    margin: auto;
    padding-right: 10px;
}

.metricLastPoll {
    display: flex;
    flex-direction: row;
    min-width: 290px;
    margin: auto;
    padding-right: 10px;
}

.metricControlMapping {
    display: flex;
    flex: 2 1 auto;
    margin: auto;
}

.metricModalText {
    color: var(--hps-blue);
}

.metricModalButtons {
    display: flex;
    justify-content: flex-end;
    margin: 10px 0px 0px 0px;
}